export default __webpack_public_path__ + "static/media/office365.44d4cba1.png";